// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
/*Variables*/
/*end Variables*/
.navbar_block {
  content: "";
  transition: 200ms;
}
.navbar_block.open {
  min-width: 190px;
}
.navbar_block.close {
  min-width: 56px;
}

.navbar {
  z-index: 95;
  position: fixed;
  top: 0;
  bottom: 0;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;
  padding: 0px;
  justify-content: space-between;
  background-color: #fff;
  transition: all 200ms;
  overflow-y: auto;
  overflow-x: hidden;
}
.navbar .navbar_logo {
  cursor: pointer;
}
.navbar.hide {
  width: 56px;
  min-width: 56px;
}
.navbar.hide .version {
  display: none;
}
.navbar.hide .navbar_top {
  width: 100%;
}
.navbar.hide .navbar_bottom {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar.hide .navbar_bottom h6 {
  display: none;
}
.navbar.hide .navbar_bottom button {
  display: none;
}
.navbar.hide .navbar_bottom svg {
  display: block;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}
.navbar.hide .navbar_bottom svg:hover {
  color: rgb(22, 109, 255);
}
.navbar.hide .navbar_logo {
  padding: 0px 5px;
  border-bottom: 1px solid rgba(30, 30, 30, 0.2);
}
.navbar.hide .navbar_logo img {
  width: 100%;
  height: 60px;
  object-fit: contain;
}
.navbar.hide .nav_list {
  height: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
.navbar.hide .nav_list a {
  color: rgba(0, 0, 0, 0.6);
  transition: 200ms;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-left: 0px solid transparent;
  font-size: 16px;
  margin: 2px 0px;
  padding: 8px 10px;
  width: 100%;
  text-align: center;
}
.navbar.hide .nav_list a span {
  display: none;
}
.navbar.hide .nav_list a svg {
  filter: opacity(0.7);
}
.navbar.hide .nav_list a:hover {
  color: rgb(22, 109, 255);
  background: rgba(194, 205, 238, 0.2);
  border-left: 0px solid rgb(22, 109, 255);
}
.navbar.open {
  width: 190px;
  min-width: 190px;
  padding: 0px 0px;
}
.navbar.open .navbar_top {
  width: 100%;
}
.navbar.open .navbar_bottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
  width: 100%;
}
.navbar.open .navbar_bottom svg {
  display: none;
}
.navbar.open .navbar_bottom h6 {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  padding-top: 40px;
  margin: 16px 0px;
  width: 100%;
  text-align: center;
  border-top: 1px solid rgba(30, 30, 30, 0.2);
}
.navbar.open .navbar_logo {
  padding: 20px 0px;
  margin: 0px 16px;
  border-bottom: 1px solid rgba(30, 30, 30, 0.2);
}
.navbar.open .navbar_logo img {
  width: 100%;
  height: 100px;
  object-fit: contain;
}
.navbar.open .nav_list {
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0px 10px;
}
.navbar.open .nav_list a {
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.6);
  margin: 2px 0px;
  padding: 8px 8px;
  transition: 200ms;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-left: 0px solid transparent;
  font-size: 16px;
}
.navbar.open .nav_list a svg {
  margin-right: 10px;
  width: 30px;
  filter: opacity(0.7);
}
.navbar.open .nav_list a:hover {
  color: rgb(22, 109, 255);
  background: rgba(194, 205, 238, 0.2);
  border-left: 0px solid rgb(22, 109, 255);
}
.navbar .toggle_nav {
  background: #fff;
  position: absolute;
  left: 100%;
  top: 50%;
  height: 120px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  padding: 1px;
  cursor: pointer;
}
.navbar .toggle_nav svg {
  transform: rotate(180deg);
  transition: all 200ms;
  filter: opacity(0.5);
}
.navbar .toggle_nav.close {
  height: 50vh;
}
.navbar .toggle_nav.close svg {
  transform: rotate(0deg);
  filter: opacity(1);
}

@media screen and (max-width: 1275px) {
  .navbar_block.open {
    min-width: 56px;
  }
  .navbar_block.close {
    min-width: 56px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/navbar/_navbar.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC9HA,YAAA;AAGA,gBAAA;AAEA;EACI,WAAA;EACA,iBDoHe;ACrDnB;AA9DI;EACI,gBARY;AAwEpB;AA9DI;EACI,eAVc;AA0EtB;;AA7DA;EACI,WDqHO;ECpHP,eAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kDDuFc;ECtFd,YAAA;EACA,8BAAA;EACA,sBDCuB;ECAvB,qBAAA;EACA,gBAAA;EACA,kBAAA;AAgEJ;AA9DI;EACI,eAAA;AAgER;AA7DI;EACI,WAlCc;EAmCd,eAnCc;AAkGtB;AA7DQ;EACI,aAAA;AA+DZ;AA5DQ;EACI,WAAA;AA8DZ;AA5DQ;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA8DZ;AA7DY;EACI,aAAA;AA+DhB;AA7DY;EACI,aAAA;AA+DhB;AA7DY;EACI,cAAA;EACA,yBD1CO;EC2CP,eAAA;AA+DhB;AA9DgB;EACI,wBDjDJ;ACiHhB;AA5DQ;EACI,gBAAA;EACA,8CAAA;AA8DZ;AA7DY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AA+DhB;AA3DQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA6DZ;AA3DY;EACI,yBDlEO;ECmEP,iBDsCG;ECrCH,4BD+BA;EC9BA,+BD8BA;EC7BA,kCAAA;EACA,eDYO;ECXP,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AA6DhB;AA3DgB;EACI,aAAA;AA6DpB;AA1DgB;EACI,oBAAA;AA4DpB;AA1DgB;EACI,wBDzFJ;EC0FI,oCD/EY;ECgFZ,wCAAA;AA4DpB;AAtDI;EACI,YA/GY;EAgHZ,gBAhHY;EAiHZ,gBAAA;AAwDR;AAtDQ;EACI,WAAA;AAwDZ;AAtDQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,WAAA;AAuDZ;AArDY;EACI,aAAA;AAuDhB;AApDY;EACI,gBAAA;EACA,yBDpHO;ECqHP,eDlCO;ECmCP,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;AAsDhB;AAlDQ;EACI,iBAAA;EACA,gBAAA;EACA,8CAAA;AAoDZ;AAlDY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAoDhB;AAhDQ;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AAkDZ;AAhDY;EACI,mBAAA;EACA,yBDpJO;ECqJP,eAAA;EACA,gBAAA;EACA,iBD9CG;EC+CH,4BDrDA;ECsDA,+BDtDA;ECuDA,kCAAA;EACA,eDxEO;AC0HvB;AAjDgB;EACI,kBAAA;EACA,WAAA;EACA,oBAAA;AAmDpB;AAjDgB;EACI,wBDtKJ;ECuKI,oCD5JY;EC6JZ,wCAAA;AAmDpB;AA7CI;EACI,gBDlKmB;ECmKnB,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,4BD7EQ;EC8ER,+BD9EQ;EC+ER,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBDtLe;ECuLf,eAAA;EACA,YAAA;EACA,eAAA;AA+CR;AA7CQ;EACI,yBAAA;EACA,qBAAA;EACA,oBAAA;AA+CZ;AA5CQ;EACI,YAAA;AA8CZ;AA7CY;EACI,uBAAA;EACA,kBAAA;AA+ChB;;AAzCA;EAEQ;IACI,eA9NU;EAyQpB;EAzCM;IACI,eAjOU;EA4QpB;AACF","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../styles/variables\";\r\n\r\n/*Variables*/\r\n$navbar_width_open: 190px;\r\n$navbar_width_closed: 56px;\r\n/*end Variables*/\r\n\r\n.navbar_block {\r\n    content: \"\";\r\n    transition: $transition_speed;\r\n    &.open {\r\n        min-width: $navbar_width_open;\r\n    }\r\n    &.close {\r\n        min-width: $navbar_width_closed;\r\n    }\r\n}\r\n.navbar {\r\n    z-index: $z_navbar;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: $side_nav_shadow;\r\n    padding: 0px;\r\n    justify-content: space-between;\r\n    background-color: $background_color_primary;\r\n    transition: all $transition_speed;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n\r\n    .navbar_logo {\r\n        cursor: pointer;\r\n    }\r\n\r\n    &.hide {\r\n        width: $navbar_width_closed;\r\n        min-width: $navbar_width_closed;\r\n\r\n        .version {\r\n            display: none;\r\n        }\r\n\r\n        .navbar_top {\r\n            width: 100%;\r\n        }\r\n        .navbar_bottom {\r\n            width: 100%;\r\n            margin-bottom: 20px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            h6 {\r\n                display: none;\r\n            }\r\n            button {\r\n                display: none;\r\n            }\r\n            svg {\r\n                display: block;\r\n                color: $text_color_dark_soft;\r\n                cursor: pointer;\r\n                &:hover {\r\n                    color: $color_primary;\r\n                }\r\n            }\r\n        }\r\n        .navbar_logo {\r\n            padding: 0px 5px;\r\n            border-bottom: 1px solid $border_color_primary;\r\n            img {\r\n                width: 100%;\r\n                height: 60px;\r\n                object-fit: contain;\r\n            }\r\n        }\r\n\r\n        .nav_list {\r\n            height: 100%;\r\n            margin-top: 20px;\r\n            display: flex;\r\n            flex-direction: column;\r\n\r\n            a {\r\n                color: $text_color_dark_soft;\r\n                transition: $transition_speed;\r\n                border-top-right-radius: $border_radius;\r\n                border-bottom-right-radius: $border_radius;\r\n                border-left: $border_active_width solid transparent;\r\n                font-size: $font-size_navigation;\r\n                margin: 2px 0px;\r\n                padding: 8px 10px;\r\n                width: 100%;\r\n                text-align: center;\r\n\r\n                span {\r\n                    display: none;\r\n                }\r\n\r\n                svg {\r\n                    filter: opacity(0.7);\r\n                }\r\n                &:hover {\r\n                    color: $color_primary;\r\n                    background: $navigation_button_color_hover;\r\n                    border-left: $border_active_width solid $color_primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.open {\r\n        width: $navbar_width_open;\r\n        min-width: $navbar_width_open;\r\n        padding: 0px 0px;\r\n\r\n        .navbar_top {\r\n            width: 100%;\r\n        }\r\n        .navbar_bottom {\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            align-items: center;\r\n            // padding: 60px 16px;\r\n            padding-bottom: 5px;\r\n            width: 100%;\r\n\r\n            svg {\r\n                display: none;\r\n            }\r\n\r\n            h6 {\r\n                font-weight: 400;\r\n                color: $text_color_dark_soft;\r\n                font-size: $font-size_navigation;\r\n                padding-top: 40px;\r\n                margin: 16px 0px;\r\n                width: 100%;\r\n                text-align: center;\r\n                border-top: 1px solid $border_color_primary;\r\n            }\r\n        }\r\n\r\n        .navbar_logo {\r\n            padding: 20px 0px;\r\n            margin: 0px 16px;\r\n            border-bottom: 1px solid $border_color_primary;\r\n\r\n            img {\r\n                width: 100%;\r\n                height: 100px;\r\n                object-fit: contain;\r\n            }\r\n        }\r\n\r\n        .nav_list {\r\n            width: 100%;\r\n            margin-top: 30px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            height: 100%;\r\n            padding: 0px 10px;\r\n\r\n            a {\r\n                white-space: nowrap;\r\n                color: $text_color_dark_soft;\r\n                margin: 2px 0px;\r\n                padding: 8px 8px;\r\n                transition: $transition_speed;\r\n                border-top-right-radius: $border_radius;\r\n                border-bottom-right-radius: $border_radius;\r\n                border-left: $border_active_width solid transparent;\r\n                font-size: $font-size_navigation;\r\n                svg {\r\n                    margin-right: 10px;\r\n                    width: 30px;\r\n                    filter: opacity(0.7);\r\n                }\r\n                &:hover {\r\n                    color: $color_primary;\r\n                    background: $navigation_button_color_hover;\r\n                    border-left: $border_active_width solid $color_primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .toggle_nav {\r\n        background: $background_color_primary;\r\n        position: absolute;\r\n        left: 100%;\r\n        top: 50%;\r\n        height: 120px;\r\n        border-top-right-radius: $border-radius;\r\n        border-bottom-right-radius: $border-radius;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        transform: translateY(-50%);\r\n        color: $text_color_dark_soft;\r\n        font-size: 12px;\r\n        padding: 1px;\r\n        cursor: pointer;\r\n\r\n        svg {\r\n            transform: rotate(180deg);\r\n            transition: all $transition_speed;\r\n            filter: opacity(0.5);\r\n        }\r\n\r\n        &.close {\r\n            height: 50vh;\r\n            svg {\r\n                transform: rotate(0deg);\r\n                filter: opacity(1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1275px) {\r\n    .navbar_block {\r\n        &.open {\r\n            min-width: $navbar_width_closed;\r\n        }\r\n        &.close {\r\n            min-width: $navbar_width_closed;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
